import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { GetMonitoringJobsResponseAdmin } from '@/backend/market'
import { JobLiveResponseEntity } from '../../domain/entities/JobLiveResponseEntity'
import { JobLiveModel } from './JobLiveModel'

export class JobLiveResponseModel extends JobLiveResponseEntity {
  constructor(dataDto: GetMonitoringJobsResponseAdmin) {
    const jobLiveModels = dataDto.jobs?.map((job) => new JobLiveModel(job))
    super()
    mapEntityProperties<JobLiveResponseEntity>(this, dataDto, {
      map: {
        jobs: jobLiveModels
      }
    })
  }
}
